import React, { useState, useEffect } from "react";
import "./Features.css";
import {
  CalculatorIcon,
  SecurityIcon,
  CloudIcon,
  ReportIcon,
  PriceTagIcon,
  ImportIcon,
} from "../icons/Icons";
import FeatureCard from "./FeatureCard";

const Features = ({ pricingRef }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="features-section">
      <h2>Why Choose Coin Basis?</h2>
      <div className="features-grid">
        <FeatureCard
          icon={<CalculatorIcon />}
          title="Accurate Cost Basis Calculation"
          description="Our proven algorithms ensure accurate cost basis calculation for your transactions"
          isMobile={isMobile}
        />
        <FeatureCard
          icon={<PriceTagIcon />}
          title="Competitive Pricing"
          description="Save up to 90% compared to other crypto tax solutions while getting the same professional-grade results"
          isMobile={isMobile}
        />
        <FeatureCard
          icon={<ReportIcon />}
          title="Detailed Reports"
          description="Get comprehensive tax reports with all necessary details for filing"
          isMobile={isMobile}
        />
        <FeatureCard
          icon={<SecurityIcon />}
          title="Secure & Private"
          description="Your data is encrypted and never shared"
          isMobile={isMobile}
        />
        <FeatureCard
          icon={<CloudIcon />}
          title="Cloud Processing"
          description="Process large transaction sets quickly with our cloud infrastructure"
          isMobile={isMobile}
        />
        <FeatureCard
          icon={<ImportIcon />}
          title="Easy Data Import"
          description="Seamlessly import your transaction history from popular portfolio tracking platforms and exchanges"
          isMobile={isMobile}
        />
      </div>
    </div>
  );
};

export default Features;
